import React from 'react';
import { Grid, Text, Heading, Flex, Box } from 'theme-ui';
import ImgLoader from '~/components/Generic/ImgLoader';

type Props = {
  expert: Queries.ActivityExpertFragment;
  index: number;
  numberOfExperts: number;
  backgroundColor: string;
};

const SecondaryExpert = ({ expert, index, numberOfExperts, backgroundColor }: Props) => {
  const { athleteName, description, image, quote, tagline } = expert;
  return (
    <Grid
      sx={{
        px: ['2.4rem', '8rem'],
        backgroundColor,
        gridArea: `secondaryExpert${index}`,
        gridTemplateColumns: '1fr',
        gridTemplateAreas: [
          `
          "athleteBlock"
          "tagline"
          "quote"
        `,
          numberOfExperts === 2
            ? `
          "tagline"
          "quote"
          "athleteBlock" 
        `
            : `
          "athleteBlock"
          "tagline"
          "quote"
        `,
        ],
        placeItems: ['start', numberOfExperts === 2 ? 'center' : 'start'],
        mx: numberOfExperts === 2 ? 'auto' : 'none',
        width: numberOfExperts === 2 ? '100%' : 'auto',
      }}
    >
      <Flex
        sx={{
          gridArea: 'athleteBlock',
          alignItems: 'center',
          gap: '2.4rem',
          mb: '1.6rem',
        }}
      >
        <ImgLoader image={image} forwardSx={{ borderRadius: '100%', height: '6rem', width: '6rem' }} />
        <Box>
          <Heading sx={{ fontSize: '1.4rem', lineHeight: 1, textTransform: 'uppercase', mb: '0.2rem' }}>
            {athleteName}
          </Heading>
          {Boolean(description) && (
            <Text
              as="div"
              variant="text.paragraphSmall"
              sx={{
                p: { m: 0 },
              }}
              dangerouslySetInnerHTML={{ __html: description?.childMarkdownRemark?.html ?? '' }}
            />
          )}
        </Box>
      </Flex>
      <Text
        variant="text.h6"
        sx={{
          gridArea: 'tagline',
          maxWidth: [null, numberOfExperts === 2 ? '810px' : 'none'],
          mx: [null, numberOfExperts === 2 ? 'auto' : null],
          mb: ['0.8rem', 0],
        }}
      >
        {tagline}
      </Text>
      {Boolean(quote) && (
        <Text
          variant="text.quote"
          as="div"
          sx={{
            gridArea: 'quote',
            p: { m: 0 },
            maxWidth: numberOfExperts === 2 ? '810px' : 'none',
            mx: numberOfExperts === 2 ? 'auto' : null,
            textAlign: ['left', numberOfExperts === 2 ? 'center' : 'left'],
          }}
          dangerouslySetInnerHTML={{ __html: quote?.childMarkdownRemark?.html ?? '' }}
        />
      )}
    </Grid>
  );
};

export default SecondaryExpert;
